import {parsePhoneNumber} from 'libphonenumber-js';

/*
 * Phone number helpers.
 */

// The formatting logic copies how we attempt to normalize phone numbers that are saved in Front contacts.
export function formatPhoneNumber(original: string) {
  const str = original.replace(/[^\d+]/g, '');
  const digitsOnly = str.replace(/\D/g, '');

  if (isPhoneShortCode(digitsOnly)) {
    return digitsOnly;
  }

  try {
    // Default parsing to US to automatically add +1. If the number is non-US and has a proper prefix (eg. +33), the default 'US' arg is ignored.
    const parsedPhone = parsePhoneNumber(str, 'US');

    return parsedPhone.format('E.164');
  } catch (err) {
    // parsePhoneNumber throws an error if the number cannot be parsed.
    // Return null to denote that the number is invalid
    return null;
  }
}

function isPhoneShortCode(str: string) {
  return str.length === 4 || str.length === 5 || str.length === 6;
}
